module.exports = __webpack_public_path__ + "img/03.af2c52f3.png";